import {
	EVENT_ACTION_REWARD_OFFERS_REDEEM_OFFER,
	EVENT_CATEGORY_ROYALTY_KPI,
} from '../../../../shared/analytics';
import { trackCustomEvent } from '../../../../shared/analytics/event/trackCustomEvent';

export function trackRedeemRewardOffer(
	id: string,
	title: string,
	screenName: string,
	points?: number,
) {
	trackCustomEvent({
		category: EVENT_CATEGORY_ROYALTY_KPI,
		action: EVENT_ACTION_REWARD_OFFERS_REDEEM_OFFER,
		id,
		label: title,
		value: points,
		screenName,
	});
}
